import React, { useEffect, useState } from 'react';
import { Paper, MenuItem } from '@material-ui/core';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';

export default function ModuleList() {
  const { setModuleType, setModuleName } = useSettingContext();
  const [modules, setModules] = useState([]);

  const getModules = async () => {
    fetch(`${baseUrl}/api/setting/GetAllModules`)
      .then((res) => res.json())
      .then(
        (result) => {
          setModules(result.items);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  useEffect(() => {
    getModules();
  }, []);

  const handleSelect = (e, value) => {
    e.preventDefault();
    setModuleType(value.moduleType);
    setModuleName(value.moduleDescription);
    console.log('module code from click', e, value);
  };

  return (
    <Paper sx={{ width: 320 }}>
      {modules.map((item, index) => (
        <MenuItem
          key={item.moduleType}
          value={item.moduleDescription}
          onClick={(event) => handleSelect(event, item)}
        >
          {item.moduleDescription ?? item.moduleType}
        </MenuItem>
      ))}
    </Paper>
  );
}
